/**
 * GoalsSummaryHeader - Top band: Goals heading, status pills, and How goals work? Cancel/Save live in GoalsMetricsConfigurator when editing.
 */
import './GoalsSummaryHeader.css'

const STATUS_LABELS = {
  achieved: 'Achieved',
  'on-track': 'On Track',
  'needs-attention': 'Needs attention',
  'at-risk': 'At Risk',
  'no-active': 'No active goals',
}

function GoalsSummaryHeader({
  activeGoalsCount = 0,
  status = 'no-active',
  timeRemainingText = '',
  onOpenGoalsHelp,
  /** When false, hide count / status / time pills (e.g. goal type selected but not yet saved & activated). */
  showSummaryPills = true,
}) {
  const statusLabel = STATUS_LABELS[status] ?? 'No active goals'
  const safeCount = typeof activeGoalsCount === 'number' && !Number.isNaN(activeGoalsCount) ? activeGoalsCount : 0

  return (
    <div className="goalsSummaryHeader">
      <div className="goalsSummaryHeaderBand">
        <div className="goalsSummaryHeaderLeft">
          <h2 className="goalsSummaryTitle">Goals</h2>
          {showSummaryPills && (
            <div className="goalsSummaryPills">
              <span className="goalsSummaryPill goalsSummaryPill--count">
                {safeCount} active goal{safeCount !== 1 ? 's' : ''}
              </span>
              <span className={`goalsSummaryPill goalsSummaryPill--status goals-active-badge goals-active-badge--${status}`}>
                {statusLabel}
              </span>
              {timeRemainingText && (
                <span className="goalsSummaryPill goalsSummaryPill--time">{timeRemainingText}</span>
              )}
            </div>
          )}
        </div>
        <div className="goalsSummaryHeaderRightCluster">
          {typeof onOpenGoalsHelp === 'function' && (
            <button
              type="button"
              className="goalsHowGoalsWorkLink"
              onClick={(e) => {
                e.stopPropagation()
                onOpenGoalsHelp()
              }}
              aria-label="How goals work"
            >
              How goals work?
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default GoalsSummaryHeader
